import { ScrollLock } from "./_scrollLock";

export class Drawer {
  #drawer;
  #button;
  #drawerOpen = false;
  #scrollLock;
  // キーボード操作
  #firstTabbable;

  constructor(elements) {
    const { drawer, button } = elements;
    this.#drawer = drawer;
    this.#button = button;
    // キーボード操作
    const tabbableElements = this.#drawer.querySelectorAll("a");
    this.#firstTabbable = tabbableElements[0];

    this.#button.addEventListener("click", this.#onClickButton);
    window.addEventListener("keydown", this.#onKeydownEsc);

    this.#scrollLock = new ScrollLock();
  }
  #changeAriaExpanded = (state) => {
    const value = state ? "true" : "false";
    this.#drawer.setAttribute("aria-expanded", value);
    this.#button.setAttribute("aria-hidden", value);
  };
  #changeState = (state) => {
    this.#changeAriaExpanded(state);
    this.#drawerOpen = state;
  };
  #openDrawer = () => {
    this.#changeState(true);
  };
  #closeDrawer = () => {
    this.#changeState(false);
  };
  #onKeydownEsc = (event) => {
    if (!this.#drawerOpen || event.key !== "Escape") {
      return;
    }
    event.preventDefault();
    this.#closeDrawer();
  };
  #onClickButton = () => {
    if (this.#drawerOpen === false) {
      this.#openDrawer();
      this.#scrollLock.activate();
      // this.#firstTabbable.focus();
      return;
    }
    this.#closeDrawer();
    this.#scrollLock.deactivate();
  };
}
